import {Component, h} from 'preact';
import 'jquery-file-download';
import constants from "../../constants";
import ShareOptions from "../header/ShareOptions";
import {connect} from "react-redux";
import reduce from "../../reducers";
import * as actions from "../../actions";
import PublishChangesButton from '../header/PublishChangesButton';

export default @connect(reduce, actions)
class MenuPublishChanges extends Component {
  render(props, state) {
    return (
      <div>
        <header className={'sb'}>
          <a onClick={props.toRoot}>
            <svg>
              <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-arrow"}/>
            </svg>
          </a>
          <h2>Publish Changes</h2>
        </header>
        <div>
          <PublishChangesButton {...props}/>
        </div>
      </div>
    )
  }
}
